import {endpoints} from './endpoints'
import request from '../request'

export function createReportTitle (data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.createReportTitle,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function updateReportTitle (data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.updateReportTitle,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function getReportTitles (params) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getReportTitles,
			method: 'get',
			params
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function deleteReportTitle (data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.deleteReportTitle,
			method: 'delete',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function updateOrderTitleReport (data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.updateOrderTitleReport,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function createReport (data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.createReport,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function updateReport (data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.updateReport,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function createReportPdfFromPreview (data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.createReportPdfFromPreview,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function sendReportPdfEmail (data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.sendReportPdfEmail,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function getCompanyReports (params) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getCompanyReports,
			method: 'get',
			params
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function getReportById (params) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getReportById,
			method: 'get',
			params
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function deleteReport (data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.deleteReport,
			method: 'delete',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function forceReportHeaderGeneration (data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.forceReportHeaderGeneration,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function newReportObservation (data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.newReportObservation,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}


export function getEditorConfig (params) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getEditorConfig,
			method: 'get',
			params
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

//Deprecar
export function createReportPdfFromPreviewLegacy (data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.createReportPdfFromPreviewLegacy,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}